import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import { IImage } from '@models/IImage';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
export interface IProductCardImage {
  readonly isProductCard?: boolean;
  readonly lazyLoad?: boolean;
  readonly productImage: IImage;
  readonly tags?: string[];
}

const ProductCardImage = ({
  productImage,
  tags,
  isProductCard = true,
  lazyLoad = true,
}: IProductCardImage) => (
  <div
    className={twMerge(
      'tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-bg-grey-20'
    )}
  >
    <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-will-change-auto">
      <Image
        image={productImage}
        imageClasses={`tw-translate-y-[4%] tw-max-h-[90%] tw-max-w-[60%] ${
          isProductCard ? 'tw-w-full' : 'tw-w-auto'
        }`}
        classes="tw-z-10 tw-relative tw-h-full tw-items-center tw-justify-center tw-flex tw-w-full"
        sizes={isProductCard ? '20vw' : '100vw'}
        lazyLoad={lazyLoad}
      />
    </div>
    {tags && !!tags.length && (
      <div
        className={classNames(
          'tw-absolute tw-left-4 tw-z-10 tw-flex tw-gap-[5px]',
          isProductCard ? 'tw-bottom-14' : 'tw-bottom-4'
        )}
      >
        {tags.map((tag) => (
          <div key={tag} className="tw-h-[25px] tw-bg-grey-40 tw-px-2">
            <Text variant="label-12" className="tw-text-grey-90">
              {tag}
            </Text>
          </div>
        ))}
      </div>
    )}
    <div className="tw-absolute tw-bottom-0 tw-left-0 tw-z-0 tw-h-[42%] tw-w-full tw-bg-gradient-to-t tw-from-white tw-to-black tw-opacity-5" />
    <div className="tw-absolute tw-bottom-[42%] tw-left-0 tw-z-0 tw-h-[68%] tw-w-full tw-bg-gradient-to-t tw-from-white tw-to-black tw-opacity-[.08]" />
  </div>
);

export default ProductCardImage;
